// Consumable subcategories — shared across the buyer page, dealer form,
// and bulk-upload config so they stay in sync with the backend.
export const CONSUMABLE_SUBCATEGORIES = [
    "Ink Cartridges",
    "Drums",
    "Fusers",
    "Maintenance Kits",
    "Staple Cartridges",
    "Transfer Belts",
    "Other",
];

export const CONSUMABLE_CONDITIONS = ["New", "Refurbished", "Compatible"];
